export default {
    data() {
        return {
           courseItems:  [
               {
                   id: 1,
                   courseImage: require(`@/assets/img/course/course-1.jpg`),
                   listImg:require(`@/assets/img/course/list/course_list_1.jpeg`),
                   lesson:'Jul 12, 2025',
                   title: 'Become a product Manager learn the skills & job.',
                   text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Eaque id in nemo quis quo. Blanditiis dolore eveniet iste quis quisquam. Deleniti earum error est excepturi id incidunt, officia officiis temporibus!',
                   rating: '09:30',
                   teacherImg: require(`@/assets/img/course/teacher/teacher-1.jpg`),
                   teacherName: 'Jim Séchen',
                   category: 'Art & Design',
                   price:'21',
                   oldPrice:'33.00'
               },
               {
                   id: 2,
                   courseImage: require(`@/assets/img/course/course-2.jpg`),
                   listImg:require(`@/assets/img/course/list/course_list_2.jpeg`),
                   lesson:'Jul 23, 2025',
                   title: 'Fundamentals of music theory Learn new',
                   text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Eaque id in nemo quis quo. Blanditiis dolore eveniet iste quis quisquam. Deleniti earum error est excepturi id incidunt, officia officiis temporibus!',
                   rating: '09:33',
                   teacherImg: require(`@/assets/img/course/teacher/teacher-2.jpg`),
                   teacherName: 'Barry Tone',
                   category: 'UX Design',
                   price:'32',
                   oldPrice:'68.00',
                   color:'sky-blue'
               },
               {
                   id: 3,
                   courseImage: require(`@/assets/img/course/course-3.jpg`),
                   listImg:require(`@/assets/img/course/list/course_list_3.jpeg`),
                   lesson:'Jul 10, 2025',
                   title: 'Bases Matemáticas dios Álgebra Ecuacion',
                   text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Eaque id in nemo quis quo. Blanditiis dolore eveniet iste quis quisquam. Deleniti earum error est excepturi id incidunt, officia officiis temporibus!',
                   rating: '10:00',
                   teacherImg: require(`@/assets/img/course/teacher/teacher-3.jpg`),
                   teacherName: 'Samuel Serif',
                   category: 'Development',
                   price:'13',
                   oldPrice:'19.00',
                   color:'green'
               },
               {
                   id: 4,
                   courseImage: require(`@/assets/img/course/course-4.jpg`),
                   listImg:require(`@/assets/img/course/list/course_list_4.jpeg`),
                   lesson:'Jul 4, 2025',
                   title: 'Strategy law and organization Foundation',
                   text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Eaque id in nemo quis quo. Blanditiis dolore eveniet iste quis quisquam. Deleniti earum error est excepturi id incidunt, officia officiis temporibus!',
                   rating: '10:15',
                   teacherImg: require(`@/assets/img/course/teacher/teacher-4.jpg`),
                   teacherName: 'Elon Gated',
                   category: 'Development',
                   price:'62',
                   oldPrice:'97.00',
                   color:'blue'
               },
               {
                   id: 5,
                   courseImage: require(`@/assets/img/course/course-5.jpg`),
                   listImg:require(`@/assets/img/course/list/course_list_5.jpeg`),
                   lesson:'Jul 15, 2025',
                   title: 'The business Intelligence analyst Course 2022',
                   text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Eaque id in nemo quis quo. Blanditiis dolore eveniet iste quis quisquam. Deleniti earum error est excepturi id incidunt, officia officiis temporibus!',
                   rating: '10:00',
                   teacherImg: require(`@/assets/img/course/teacher/teacher-5.jpg`),
                   teacherName: 'Eleanor Fant',
                   category: 'Marketing',
                   price:'25',
                   oldPrice:'36.00',
                   color:'orange'
               },
               {
                   id: 6,
                   courseImage: require(`@/assets/img/course/course-6.jpg`),
                   listImg:require(`@/assets/img/course/list/course_list_6.jpeg`),
                   lesson:'Jul 14, 2025',
                   title: 'Bases Matemáticas dios Álgebra Ecuacion',
                   text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Eaque id in nemo quis quo. Blanditiis dolore eveniet iste quis quisquam. Deleniti earum error est excepturi id incidunt, officia officiis temporibus!',
                   rating: '10:10',
                   teacherImg: require(`@/assets/img/course/teacher/teacher-6.jpg`),
                   teacherName: 'Brian Cumin',
                   category: 'Data Science',
                   price:'35',
                   oldPrice:'46.00',
                   color:'pink'
               },
               {
                   id: 7,
                   courseImage: require(`@/assets/img/course/course-7.jpg`),
                   listImg:require(`@/assets/img/course/list/course_list_7.jpeg`),
                   lesson:'Jun 24, 2025',
                   title: 'Build your media and Public presence',
                   text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Eaque id in nemo quis quo. Blanditiis dolore eveniet iste quis quisquam. Deleniti earum error est excepturi id incidunt, officia officiis temporibus!',
                   rating: '11:00',
                   teacherImg: require(`@/assets/img/course/teacher/teacher-7.jpg`),
                   teacherName: 'Pelican Steve',
                   category: 'Audio & Music',
                   price:'46',
                   oldPrice:'72.00',
                   color:'orange'
               },
               {
                   id: 8,
                   courseImage: require(`@/assets/img/course/course-8.jpg`),
                   listImg:require(`@/assets/img/course/list/course_list_8.jpeg`),
                   lesson:'Jun 16, 2025',
                   title: 'Creative writing through Storytelling',
                   text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Eaque id in nemo quis quo. Blanditiis dolore eveniet iste quis quisquam. Deleniti earum error est excepturi id incidunt, officia officiis temporibus!',
                   rating: '10:50',
                   teacherImg: require(`@/assets/img/course/teacher/teacher-8.jpg`),
                   teacherName: 'Shahnewaz Sakil',
                   category: 'Mechanical',
                   price:'52',
                   oldPrice:'72.00',
                   color:'pink'
               },
               {
                   id: 9,
                   courseImage: require(`@/assets/img/course/course-9.jpg`),
                   listImg:require(`@/assets/img/course/list/course_list_9.jpeg`),
                   lesson:'Jun 14, 2025',
                   title: 'Product Manager Learn the Skills & job.',
                   text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Eaque id in nemo quis quo. Blanditiis dolore eveniet iste quis quisquam. Deleniti earum error est excepturi id incidunt, officia officiis temporibus!',
                   rating: '12:05',
                   teacherImg: require(`@/assets/img/course/teacher/teacher-9.jpg`),
                   teacherName: 'Hilary Ouse',
                   category: 'Lifestyle',
                   price:'15',
                   oldPrice:'45.00',
                   color:'blue-2'
               },
           ]
        }
    }
}
